import React, { createContext, useState, useEffect, useCallback } from "react";
import { getAPIURL, setCachedBusiness, getCachedBusiness } from "../lib/utils";
import { withActiveToken } from "../lib/auth";
import { useRouter } from "next/router";

const UserContext = createContext({
  user: null,
  fetchUserData: () => {},
});

export const UserProvider = (props) => {
  const [user, setUser] = useState(null);
  const router = useRouter();

  // Wrap fetchUserData in useCallback to avoid recreating it on every render
  const fetchUserData = useCallback(() => {
    return withActiveToken(() => {
      fetch(getAPIURL("users/me/"), {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        if (res.ok) {
          return res.json().then((json) => {
            setUser(json);
          });
        }
        return res.json().then((json) => Promise.reject(json));
      });
    }, router);
  }, [router]);

  useEffect(() => {
    if (user == null) {
      fetchUserData();
    }
  }, [router.pathname, user, fetchUserData]);

  const context = {
    user,
    fetchUserData,
  };

  return (
    <UserContext.Provider value={context}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;
